<template>
    <div id="press" class="team press">
      <div class="team-block" v-for="(item, index) in press" :key="index">
        <span class="team-block--meta" v-text="item.published_at"></span>
        <span class="team-block--title pointer scrollFadeText" @click.prevent="goToLink(item.link)">{{item.title}}</span>
        <p class="team-block--content scrollFadeBody">
          {{ item.text }}
        </p>
      </div>
    </div>
</template>

<script>
    // eslint-disable-next-line no-unused-vars
    const dataLayer = window.dataLayer || [];
    dataLayer.push({
        'event': 'PageView',
        'pagePath': '/press',
        'pageTitle': 'Parker West | Press'
    })
    export default {
      name: "Press",
      data: () => ({
        press: []
      }),
        metaInfo: {
            // Define meta tags here.
            titleTemplate: '%s ← Press',
            meta: [
                {name: 'description', content: 'Press penthouse page'}
            ],
            link: [
                {rel: 'canonical', href: 'http://test.parkerwest.com/'}
            ]
        },
      created() {
          this.press = window.data.press;
          window.addEventListener('scroll', this.handleScroll);
      },
      methods: {
        handleScroll () {
            // Scroll fade
            let slidesTitle = document.getElementsByClassName("scrollFadeText");
            let slidesBody = document.getElementsByClassName("scrollFadeBody");


            for (let i = 0; i < slidesTitle.length; i++) {
                let elPos = slidesTitle[i].getBoundingClientRect().top
                if(elPos < 120) {
                    slidesTitle[i].style.opacity = (elPos / 200)
                } else {
                    slidesTitle[i].style.opacity = 1
                }
            }

            for (let i = 0; i < slidesBody.length; i++) {
                let elPos = slidesBody[i].getBoundingClientRect().top
                if(elPos < 120) {
                    slidesBody[i].style.opacity = (elPos / 200)
                } else {
                    slidesBody[i].style.opacity = 1
                }
            }
        },

        goToLink(url) {
            return window.open(url, '_blank')
        },
      },
      destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
      },
    }
</script>

<style scoped>

</style>
